<i18n>
{
  "en": {
    "error": {
      "notHalfWidthText": "contains non-alphanumeric characters"
    }
  },
  "ja": {
    "error": {
      "notHalfWidthText": "に半角英数記号以外の文字が含まれています"
    }
  }
}
</i18n>
<template>
  <label>
    <span v-if="$slots.label"><slot name="label"></slot></span>
    <br v-if="labelbr" />
    <input
      :type="type"
      :name="name"
      :style="styles"
      :placeholder="placeholderValue"
      :value="value"
      @input="updateValue"
      :readonly="readonly"
      :labelbr="labelbr"
      :autocomplete="autocomplete"
    />
    <div class="hint_text">{{ hint }}</div>
  </label>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'text'
    },
    name: {},
    label: {},
    value: {},
    color: {},
    width: {},
    readonly: {},
    placeholderValue: {},
    labelbr: null,
    autocomplete: {},
    hint: {}
  },
  methods: {
    updateValue(e) {
      this.$emit('input', e.target.value);
      this.$emit('change', e.target.value);
    }
  },
  computed: {
    // バインドするスタイルを生成
    styles() {
      return {
        '--color': this.color,
        '--width': this.width
      };
    }
  },
  created() {
    const notHalfWidthTextMsg = this.$t('error.notHalfWidthText');
    console.log(this.name);
    this.$validator.extend('password', {
      current: null,
      getMessage(field) {
        return field + notHalfWidthTextMsg;
      },
      validate(value) {
        if (value.match(/[^\x21-\x7E]+/)) {
          return false;
        } else {
          return true;
        }
      }
    });

    this.$validator.attach({
      name: 'password',
      alias: 'パスワード',
      rules: 'password',
      getter: () => this.value
    });
  }
};
</script>

<style lang="stylus" scoped>
input // Firefoxでのフォーカスは効かない
  border:0;
  padding:10px;
  font-size:1em;
  border:solid 1px #ccc !important;
  margin: 0 0 5px;
  -webkit-box-shadow: 0px 1px rgba(255, 255, 255, 0.5);
  -moz-box-shadow: 0px 1px rgba(255, 255, 255, 0.5);
  box-shadow: 0px 1px rgba(255, 255, 255, 0.5);
  -webkit-border-radius: 4px !important;
  -moz-border-radius: 4px !important;
  border-radius: 4px !important;
  -moz-box-shadow: inset 0 0 4px rgba(0,0,0,0.2);
  -webkit-box-shadow: ins t 0 0 4px rgba(0, 0, 0, 0.2);
  box-shadow: inner 0 0 4px rgba(0, 0, 0, 0.2);
  --color: white
  --width: 100%
  background-color: var(--color);
  width: var(--width);
.hint_text
  margin: 0 0 15px;
</style>
